<template>
<div>
  <form class="ui form" @submit.prevent="search()">
    <h4 class="ui dividing header">検索条件</h4>
    <div class="fields">
      <div class="field">
        <label>受話ステータス</label>
        <dropdown v-model="searchForm.model.call_completed" :placeholder="'すべて'" @change="search()">
          <option value="">すべて</option>
          <option value="true">出た</option>
          <option value="false">出てない</option>
        </dropdown>
      </div>
      <div class="field">
        <label>未対応/対応済</label>
        <dropdown v-model="searchForm.model.shop_status" :placeholder="'すべて'" @change="search()">
          <option value="">すべて</option>
          <option value="initial">未対応</option>
          <option value="completed">対応済</option>
        </dropdown>
      </div>
      <div class="field">
        <label>発信日</label>
        <datepick v-model="searchForm.model.called_at_from" :placeholder="'開始日'" @change="search()"></datepick>
      </div>
      <div class="field">
        <label>&nbsp;</label>
        <span style="display: inline-block; margin-top: 50%;">〜</span>
      </div>
      <div class="field">
        <label>&nbsp;</label>
        <datepick v-model="searchForm.model.called_at_to" :placeholder="'終了日'" @change="search()"></datepick>
      </div>
      <div class="field">
        <label>店舗ID</label>
        <div class="ui action input">
          <input type="text" v-model="searchForm.model.shop_id" placeholder="店舗ID">
          <button class="ui teal button">Search</button>
        </div>
      </div>
      <div class="field">
        <label>発信者番号</label>
        <div class="ui action input">
          <input type="text" v-model="searchForm.model.tel" placeholder="発信者番号">
          <button class="ui teal button">Search</button>
        </div>
      </div>
    </div>
    <!-- <div class="fields">
        <div class="field">
          <label>人数</label>
          <input type="text" v-model="searchForm.model.num_people_from">
        </div>
        <div class="field">
          <label>&nbsp;</label>
          <span style="display: inline-block; margin-top: 50%;">〜</span>
        </div>
          <div class="field">
            <label>&nbsp;</label>
            <div class="ui action input">
            <input type="text" v-model="searchForm.model.num_people_to">
            <button class="ui teal button">Search</button>
            </div>
          </div>
        
        <div class="field">
          <label>予約日</label>
          <datepick v-model="searchForm.model.reserve_date_from" :placeholder="'開始日'" @change="search()"></datepick>
        </div>
        <div class="field">
          <label>&nbsp;</label>
          <span style="display: inline-block; margin-top: 50%;">〜</span>
        </div>
        <div class="field">
          <label>&nbsp;</label>
          <datepick v-model="searchForm.model.reserve_date_to" :placeholder="'終了日'" @change="search()"></datepick>
        </div>
    </div>   -->
  </form>

  <div class="search-result" :class="{'loading': searchForm.waiting}">
    <div class="ui vertical centered loader" :class="{'active': searchForm.waiting}"></div>
    <div class="ui horizontal divider header">検索結果</div>
    <div class="relative">
      <pagination :pager="pager" :callback="search"></pagination>
      <div style="display: inline-block; position: absolute; right: 0; bottom: 0;">
        <button @click="download" type="button" class="ui small yellow button"><i class="download icon"></i>CSVでダウンロードする</button>
      </div>
    </div>
    <table class="ui compact table">
      <thead>
        <tr>
          <th>メモ</th>
          <th>発信日時</th>
          <th>店舗(ID)</th>
          <th>発信者番号</th>
          <th>受話</th>
          <th>ステータス</th>
          <th>名前</th>
          <th>日時/人数</th>
          <th>録音</th>
          <th>通話時間</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="call in calls" :key="call.id" :class="{'new': call.shop_status === 'initial'}">
          <td><i class="edit icon clickable" @click="openMemoEditDialog(call)" /></td>
          <td>{{ call.created_at | formatDatetime }}</td>
          <td>{{ call.shop.name }}({{ call.shop.id }})</td>
          <td><a :href="call.tel">{{ call.tel_display }}</a></td>
          <td>
            <span v-if="call.is_accepted">出た</span>
            <span v-else>出てない</span>
          </td>
          <td style="width: 200px;">
            <dropdown v-model="call.shop_status" @change="saveShopStatus(call)">
              <option value="initial">未対応</option>
              <option value="completed">対応済</option>
            </dropdown>
          </td>
          <td>
            <a v-if="call.name_recording_url" :href="call.name_recording_url" target="_blank">確認する</a>
          </td>
          <td>
            <a v-if="call.details_recording_url" :href="call.details_recording_url" target="_blank">確認する</a>
          </td>
          <td>
            <a v-if="call.recording_url" :href="call.recording_url" target="_blank">確認する</a>
          </td>
          <td>
            <span>{{ call.duration }}</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div id="memo-edit-dialog" class="ui small modal">
    <div class="scrolling content">
      <form class="ui form" :class="{'warning': memoEditForm.hasErrors()}">
        <div class="required field">
          <label>メモ</label>
          <textarea v-model="memoEditForm.model.memo" readonly />
          <validation-message :form="memoEditForm" field="memo"></validation-message>
        </div>
      </form>
    </div>
    <div class="actions">
      <div class="ui button" @click="closeMemoEditDialog">閉じる</div>
    </div>
  </div>
</div>
</template>

<script>
export default {
    data: function() {
        return {
            searchForm: this.createForm(_.defaults(this.query(), {
                'called_at_from': moment().add('M', -1).startOf('month').format('YYYY/MM/DD'),
            })),
            pager: this.createPager(100, this.query().offset),
            calls: [],
            memoEditForm: this.createForm(),
        };
    },
    created: function() {
        this.search(this.pager.current());
    },
    methods: {
        search: function(opt_position) {
            var position = opt_position || this.pager.first();
            this.merge(this.searchForm.model, position);
            this.replaceStateQuery(this.searchForm.model, ['limit']);
            return this.searchForm.get('/afadmin/api/direct_calls', function(response) {
                this.calls = response.data;
                this.pager.update(response.data, response);
            }.bind(this));
        },
        download: function() {
            var link = document.createElement('a');
            link.href = '/afadmin/api/direct_calls' + window.location.search + '&download';
            document.body.appendChild(link);
            link.click();
        },
        saveShopStatus(call) {
            this.createForm({shop_status: call.shop_status}).put(`/afadmin/api/direct_calls/${call.id}/`);
        },
        openMemoEditDialog(call) {
            this.memoEditForm.model = call;
            $('#memo-edit-dialog').modal({
                autofocus: true,
                closable: true
            }).modal('show');
        },
        closeMemoEditDialog() {
            $('#memo-edit-dialog').modal('hide');
        }
    }
};
</script>
